// extracted by mini-css-extract-plugin
export default {"imageWrap":"ContactLocation_imageWrap__-6gh-","fadeIn":"ContactLocation_fadeIn__XyJV8","image":"ContactLocation_image__s6HZB"};